import { CircularProgress } from '@mui/material';
import {
  BackgroundContainer,
  ComponentOverlayContainer,
  SpinnerContainer,
  SpinnerOverlayContainer,
} from './Spinner.styles';
import { SpinnerProps } from './SpinnerProps';

const Spinner = (props: SpinnerProps): JSX.Element => {
  return props.overlay ? (
    props.component ? (
      props.loading ? (
        <ComponentOverlayContainer>
          <SpinnerContainer>
            <CircularProgress />
          </SpinnerContainer>
        </ComponentOverlayContainer>
      ) : (
        <></>
      )
    ) : props.loading ? (
      <BackgroundContainer>
        <SpinnerOverlayContainer>
          <CircularProgress />
        </SpinnerOverlayContainer>
      </BackgroundContainer>
    ) : (
      <></>
    )
  ) : (
    <SpinnerContainer>
      <CircularProgress />
    </SpinnerContainer>
  );
};

export default Spinner;
